import { render, staticRenderFns } from "./AddressCardComponent.vue?vue&type=template&id=ce54de9e&scoped=true&"
import script from "./AddressCardComponent.vue?vue&type=script&lang=js&"
export * from "./AddressCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce54de9e",
  null
  
)

export default component.exports